var styleDataHash = "b08b7ffd";
const injectCss = () => {
  var css = `.UmV8b{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .UmV8b{border:0}[dir=ltr] .UmV8b{left:0}[dir=rtl] .UmV8b{right:0}.KGXfg{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .KGXfg,[dir=rtl] .KGXfg{left:0;right:0}._06LrD{height:0;position:relative}[dir] ._06LrD{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){._06LrD{min-width:auto}}}@container (width < 640px){._06LrD{min-width:auto}}.tst5G{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .tst5G{cursor:move}.tst5G~*>*{pointer-events:none}._2nt9n{height:0;overflow:hidden;visibility:hidden;width:0}.BF0yh,._2nt9n{position:absolute}.BF0yh{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .BF0yh{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .BF0yh{right:0}[dir=rtl] .BF0yh{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "UmV8b",
  "videoOverlay": "KGXfg",
  "video_container": "_06LrD",
  "video_overlay": "tst5G",
  "hide_duration": "_2nt9n",
  "error": "BF0yh"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
